import { render, staticRenderFns } from "./ticker.vue?vue&type=template&id=69287bc8"
import script from "./ticker.vue?vue&type=script&lang=js"
export * from "./ticker.vue?vue&type=script&lang=js"
import style0 from "./ticker.vue?vue&type=style&index=0&id=69287bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports